import { render, staticRenderFns } from "./CheckboxCellColumn.vue?vue&type=template&id=38f85c28&functional=true&"
import script from "./CheckboxCellColumn.vue?vue&type=script&lang=js&"
export * from "./CheckboxCellColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports